import React from 'react';
import { Check, Copy, AlertTriangle } from 'lucide-react';
import { useWorkbenchToast } from '../shared/toast';

export default function KeyCreatedModal({ keyData, onClose }) {
  const toast = useWorkbenchToast();

  const handleCopy = () => {
    navigator.clipboard.writeText(keyData.key);
    toast.copied();
  };

  return (
    <div className="workbench-modal-overlay" onClick={onClose}>
      <div className="workbench-modal workbench-modal-centered" onClick={(e) => e.stopPropagation()}>
        <div className="key-created-icon">
          <Check size={28} />
        </div>

        <h2 className="key-created-title">API Key Created</h2>

        <div className="key-warning">
          <AlertTriangle size={16} />
          <span>This key will only be shown once. Copy and store it securely!</span>
        </div>

        <div className="key-display">
          <code className="key-value">{keyData.key}</code>
          <button className="workbench-btn workbench-btn-primary" onClick={handleCopy}>
            <Copy size={16} /> Copy to Clipboard
          </button>
        </div>

        <button className="workbench-btn workbench-btn-secondary full-width" onClick={onClose}>
          Done
        </button>
      </div>
    </div>
  );
}
